function waitForSwiperSlider(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper !== "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}

function waitForjQuery(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}

// Main slider
function mainSlider() {
  // Main swiper slider
  var mainSwiper = document.querySelector(
    '.nira-before-after [data-swiper="before-after"]'
  );
  if (mainSwiper) {
    var thumbId = mainSwiper.getAttribute("data-thumb");
    var swiperThumbs = document.querySelector(`.nira-before-after #${thumbId}`);
    var thumbSlides = swiperThumbs?.querySelectorAll(".swiper-slide");

    // Hide thumbnails
    if (thumbSlides.length < 2) {
      document
        .querySelector(".before-after-top")
        ?.classList.add("nira-thumbails-hide");
    }

    var gthumbs = new Swiper(swiperThumbs, {
      slidesPerView: 5,
      spaceBetween: 0,
      autoplay: {
        delay: 7000, // Delay between slides in milliseconds
      },
      loop: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".nira-thumbnails .swiper-button-next",
        prevEl: ".nira-thumbnails .swiper-button-prev",
      },
      breakpoints: {
        0: {
          spaceBetween: 0,
          centeredSlides: false,
          slidesPerView: "auto",
        },
        1200: {
          spaceBetween: 0,
          slidesPerView: 5,
          centeredSlides: false,
        },
      },
    });

    var swiper = new Swiper(mainSwiper, {
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: {
        delay: 7000, // Delay between slides in milliseconds
        disableOnInteraction: false,
        pauseOnMouseEnter: true, // Pause autoplay on mouse enter
        pauseOnMouseLeave: false, // Resume autoplay on mouse leave
      },
      loop: true,
      allowTouchMove: false,
      // pagination: {
      //   el: ".before-after-bottom .swiper-pagination",
      //   clickable: true, // optional: enables clicking on pagination bullets
      // },
      thumbs: {
        swiper: gthumbs,
      },
    });

    // Pause autoplay on mouse enter
    // swiper.el?.addEventListener("mouseenter", function () {
    //   swiper.autoplay.stop();
    // });

    // Resume autoplay on mouse leave
    // swiper.el?.addEventListener("mouseleave", function () {
    //   swiper.autoplay.start();
    // });
  }
}

// Change right product
function changeRightProduct(slide) {
  var index = slide.realIndex;
  var parentElm = slide.el?.closest(".before-after-bottom-row");
  // Manually handle thumbnail click event
  var thumbnails = parentElm?.querySelectorAll(
    `.before-after-filter-thumbs .swiper-slide`
  );
  var imgSrc =
    thumbnails[index]?.querySelector("img")?.getAttribute("alt") || "";
  var rightColumn = parentElm?.querySelector(".before-after-right-col");

  // Right testimonial slider
  var thumbsTestimonails = thumbnails[index]?.querySelector(
    '[data-type="testimonial-content"]'
  );
  thumbsTestimonails =
    thumbsTestimonails?.innerHTML.trim(" ") ||
    rightColumn?.querySelector('[data-id="testimonial-backup"]')?.innerHTML;
  var testimonials = rightColumn?.querySelectorAll(
    '.testimonial-content[data-id="testimonial-wrapper"]'
  );

  if (imgSrc?.includes("HALF_FACE")) {
    rightColumn?.classList.add("nira-half-face");
  } else {
    rightColumn?.classList.remove("nira-half-face");
  }

  // Update testimonail content
  if (thumbsTestimonails && testimonials.length > 0) {
    testimonials.forEach(function (testimonial) {
      testimonial.innerHTML = thumbsTestimonails;
    });
  }
}

// Filter slider
function filterSlider() {
  // Filter swiper slider
  var filterSwipers = document.querySelectorAll(
    '.nira-before-after [data-swiper="filter-swiper"]'
  );
  filterSwipers?.forEach(function (fSwiper) {
    var thumbId = fSwiper.getAttribute("data-thumb");
    var leftColumn = fSwiper.closest(".before-after-left-col");
    var thumb = leftColumn?.querySelector(`.nira-before-after #${thumbId}`);

    // New thumbs
    var fthumbs = new Swiper(thumb, {
      slidesPerView: 6,
      spaceBetween: 15,
      loop: false,
      direction: "vertical",
      navigation: {
        nextEl: `[data-id="${thumbId}"] .swiper-button-next`,
        prevEl: `[data-id="${thumbId}"] .swiper-button-prev`,
      },
      breakpoints: {
        0: {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 10,
        },
        500: {
          direction: "vertical",
          slidesPerView: 5,
          spaceBetween: 10,
        },
        800: {
          direction: "vertical",
          slidesPerView: 6,
          spaceBetween: 15,
        },
      },
    });

    new Swiper(fSwiper, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      allowTouchMove: false,
      effect: "fade",
      thumbs: {
        swiper: fthumbs,
      },
      on: {
        init: function (slide) {
          changeRightProduct(slide);
        },
        slideChange: function (slide) {
          changeRightProduct(slide);
        },
      },
    });
  });
}

// Wait for swiper slider
waitForSwiperSlider(function () {
  // Main slider
  mainSlider();

  filterSlider();
  setTimeout(function () {
    filterSlider();
  }, 1000);
});

// Before after effect
waitForjQuery(function () {
  var $ = window.jQuery;

  // Before after effect
  $(".nira-before-after .r_beforeAfterContent").each(function (i, el) {
    $(el)
      .find("#control")
      .draggable({
        axis: "x",
        containment: "parent",
        drag: function (e, ui) {
          $(el)
            .find("#r_a_before")
            .css("width", ui.position.left + 34 + "px");
        },
      })
      .trigger("drag");
  });
});
